import Vue from 'vue';
import Router from 'vue-router';
import MainCOMUNE from '@/views/MainCOMUNE.vue';
import Header from '@/components/COMUNE/Header.vue';
import About from '@/components/COMUNE/About.vue';
import Login from '@/components/COMUNE/Login.vue';
import Home from '@/components/COMUNE/Home.vue';
import {i18n} from "@/main";

Vue.use(Router);

const routerCOMUNE = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:lang/',
            name: '',
            component: MainCOMUNE,
            children: [
                {
                    path: '',
                    name: 'home',
                    alias: '',
                    components: {
                        header: Header,
                        default: Home,
                    },
                },
                {
                    path: 'info/',
                    name: 'info',
                    components: {
                        header: Header,
                        default: About,
                    },
                },
                {
                    path: 'login/',
                    name: 'login',
                    components: {
                        header: Header,
                        default: Login,
                    },
                },
            ],
        },
    ],
});


routerCOMUNE.beforeEach((to, from, next) => {
    const lang = to.params.lang;
    if (!['en', 'it'].includes(lang)) return next('/it');
    if (i18n.locale !== lang) i18n.locale = lang;
    return next();
});

export default routerCOMUNE;
